<template>
  <div class="product-container">
    <nav class="add-navigation">
      <div class="right-wrapprr">
        <search-input
          class="search-input"
          type="text"
          v-model="SearchCompany"
          placeholder="Search for company"
        />
        <div class="selects-wrapper">
          <span class="filter_by">Filter by:</span>
          <primary-select type="text" class="company" placeholder="Company">
            <option>Reseller</option>
          </primary-select>
          <primary-select type="text" class="choose-company" placeholder="Select">
            <option>Choose Reseller</option>
          </primary-select>
        </div>
      </div>
      <div class="buttons-wrapper">
        <div class="primary-button">
          <primary-button @click.native="$router.push({name: 'reseller-add-company'})">Add Company</primary-button>
        </div>
      </div>
    </nav>
    <table class="Invoice_table">
      <thead>
        <tr class="Invoice_table_header">
          <th class="companyName">Company Name</th>
          <th class="balance">Balance</th>
          <th class="CreatedBy">Prepay/Postpay</th>
          <th class="speace"></th>
          <th class="contact">Contact Person</th>
          <th>Resellers</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <!-- <tr class="Invoice_table_sub_header" v-if="ownCompanies.length > 0">
                <th>My Companies</th>
            </tr> 
            <tr class="line" v-if="ownCompanies.length > 0" v-for="(ownCompaniy, key) in ownCompanies"
                :key="key" >
                <th><img class="popup_image" src="@/assets/person.jpg" alt="">{{ownCompaniy.companyName}}</th>
                <th>{{ownCompaniy.balance}}</th>
                <th>{{ownCompaniy.prepay}}</th>
                <th class="smsText">{{ownCompaniy.contactPerson}}</th>
                <th class="">{{ownCompaniy.resaller}}</th>
                <th class="Invoice_table_popup" >  // @click="showDropDown = !showDropDown" :class="showDropDown ? 'active' : ''" 
                    <span class="popup_cta">...</span>
                    <download-attachment-drop-down v-click-outside="outside"
                            v-if="showDropDown" :key="invoice.invoiceId"/>
                </th>
                <th class="icon">
                    <svg class="svg-grey"
                     .   width="30px"
                      .  height="30px"
                       .................................................................................................................................................................................................................................................................................................................................................................................... viewBox="0 0 30 30"
                        version="1.1">
                        <path d="M24.302168,8.01773234 L5.67750678,8.01773234 C5.30336043,8.01773234 5,8.32983271 5,8.71475836 L5,22.2642751 C5,22.649145 5.30336043,22.9613011 5.67750678,22.9613011 L24.302168,22.9613011 C24.6762602,22.9613011 24.9796748,22.649145 24.9796748,22.2642751 L24.9796748,8.71475836 C24.9796748,8.32988848 24.6762602,8.01773234 24.302168,8.01773234 Z M23.6246612,21.5673048 L6.35501355,21.5673048 L6.35501355,9.41178439 L23.6246612,9.41178439 L23.6246612,21.5673048 Z M8.1303523,12.695223 L14.6344173,16.8181041 C14.7433604,16.8871933 14.8665583,16.92171 14.9898103,16.92171 C15.1130623,16.92171 15.2362602,16.8871933 15.3452033,16.8181041 L21.8492683,12.695223 C22.1678049,12.4933086 22.2669919,12.0638848 22.0707317,11.736171 C21.8744715,11.4084572 21.4569648,11.3064126 21.1385366,11.5083829 L14.9898103,15.4059294 L8.84113821,11.5083829 C8.52271003,11.3065799 8.10531165,11.4084015 7.90894309,11.736171 C7.71262873,12.063829 7.81176152,12.4933086 8.1303523,12.695223 Z" 
                            id="path-1">
                        </path>
                    </svg>
                    <svg class="svg-grey"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1">
                        <path d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z" 
                            id="path-1">
                        </path>
                    </svg>
                    <svg class="svg-grey"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1">
                        <path d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z" 
                            id="path-1">
                        </path>
                    </svg>
                </th>
        </tr>-->
        <!-- <tr class="Invoice_table_sub_header" v-if="selectedcompanies.length > 0">
                <th class="allcompanies">All Companies</th>
        </tr>-->
        <tr
          class="line"
          v-if="allcompanies.length > 0"
          v-for="(company, k) in allcompanies"
          :key="k"
        >
          <th>
            <img
              class="popup_image"
              v-if="company.logo_file_uuid"
              :src="`http://88.198.219.62/api_smsc/v1/file/${company.logo_file_uuid}`"
              alt
            />
            <img class="popup_image" v-else alt />
            {{company.companyName}}
          </th>
          <th>${{company.balance}}</th>
          <th>{{company.prepay}}</th>
          <th class="speace"></th>
          <th class="smsText">{{company.contactPerson}}</th>
          <th class>{{company.resaller}}</th>
          <th class="icon">
            <svg class="svg-grey" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
              <path
                d="M24.302168,8.01773234 L5.67750678,8.01773234 C5.30336043,8.01773234 5,8.32983271 5,8.71475836 L5,22.2642751 C5,22.649145 5.30336043,22.9613011 5.67750678,22.9613011 L24.302168,22.9613011 C24.6762602,22.9613011 24.9796748,22.649145 24.9796748,22.2642751 L24.9796748,8.71475836 C24.9796748,8.32988848 24.6762602,8.01773234 24.302168,8.01773234 Z M23.6246612,21.5673048 L6.35501355,21.5673048 L6.35501355,9.41178439 L23.6246612,9.41178439 L23.6246612,21.5673048 Z M8.1303523,12.695223 L14.6344173,16.8181041 C14.7433604,16.8871933 14.8665583,16.92171 14.9898103,16.92171 C15.1130623,16.92171 15.2362602,16.8871933 15.3452033,16.8181041 L21.8492683,12.695223 C22.1678049,12.4933086 22.2669919,12.0638848 22.0707317,11.736171 C21.8744715,11.4084572 21.4569648,11.3064126 21.1385366,11.5083829 L14.9898103,15.4059294 L8.84113821,11.5083829 C8.52271003,11.3065799 8.10531165,11.4084015 7.90894309,11.736171 C7.71262873,12.063829 7.81176152,12.4933086 8.1303523,12.695223 Z"
                id="path-1"
              />
            </svg>
            <svg
              @click="$router.push({name: 'reseller-edit-company', params: {id: company.companyId}})"
              class="svg-grey"
              width="30px"
              height="30px"
              viewBox="0 0 30 30"
              version="1.1"
            >
              <path
                d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                id="path-1"
              />
            </svg>
            <svg
              @click="deleteCompany(company.companyId)"
              class="svg-grey"
              width="30px"
              height="30px"
              viewBox="0 0 30 30"
              version="1.1"
            >
              <path
                d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                id="path-1"
              />
            </svg>
            <div class="Invoice_table_popup">
              <b-dropdown variant="link" size="lg" no-caret>
                <template slot="button-content">
                  <span class="popup_cta">...</span>
                </template>
                <b-dropdown-item
                  href="#"
                  @click="$router.push({name: 'reseller-companies-payment-history', params: {id: company.companyId}})"
                >Payment History</b-dropdown-item>
                <b-dropdown-item
                  href="#"
                  @click="$router.push({name: 'reseller-companies-invoice-history', params: {id: company.companyId}})"
                >Invoice History</b-dropdown-item>
                <b-dropdown-item
                  href="#"
                  @click="$router.push({name: 'reseller-companies-transaction-history'})"
                >Transaction History</b-dropdown-item>
                <b-dropdown-item
                  href="#"
                  @click="$router.push({name: 'reseller-companies-add-manual-payment'})"
                >Add Mannual payment</b-dropdown-item>
              </b-dropdown>
            </div>
          </th>
        </tr>
      </tbody>
    </table>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :per-page="per_page"
        :total="TotalPages"
        :qnt="allcompanies.length"
      />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue")
  },
  data: () => ({
    showDropDown: false,
    allcompanies: [],
    ownCompanies: [],
    companyName: "",
    isApproved: false,
    Page: 0,
    SearchCompany: "",
    TotalPages: null
  }),
  created() {
    this.getAllCompanies();
  },
  watch: {
    SearchCompany() {
      this.Page = 0;
      this.getAllCompanies();
    }
  },
  methods: {
    changePage(page) {
      this.Page = page;
      this.getAllCompanies(this.Searched, this.Page);
    },
    getAllCompanies() {
      this.$store
        .dispatch("GetCompanyList", {
          page: this.Page,
          company_name: this.SearchCompany
        })
        .then(res => {
          this.Page = res.page;
          this.TotalPages = res.total / res.per_page;
          console.log("res111--->", res);
          this.allcompanies = res.items.map(this.transformCompanies);
        });
    },
    transformCompanies(i, k) {
      return {
        companyName: i.company_name,
        balance: i.balance,
        prepay: i.prepay,
        contactPerson: i.contact.full_name,
        logo_file_uuid: i.contact.logo_file_uuid,
        resaller: i.reseller_name,
        companyId: i.company_uuid,
        isApproved: i.is_approved
      };
    },
    deleteCompany(companyId) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this company!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("DeleteCompany", companyId)
            .then(res => {
              console.log("res--->", res);
              this.getAllCompanies();
              this.$swal(
                "Deleted!",
                "Your company has been deleted.",
                "success"
              );
            })
            .catch(err => {
              this.$snotify.error(err.response.statusText);
            });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.product-container {
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .right-wrapprr {
      display: flex;
      align-items: center;
      width: fit-content;
      .search-input {
        height: 40px;
        width: 345px;
        background-color: #ffffff;
      }
      .selects-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
        .filter_by {
          height: 40px;
          width: 85px;
          color: #55616e;
          font-weight: normal;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
          padding: 10px 0 10px 30px;
        }
        .company {
          height: 40px;
          width: 150px;
          padding: 0 0 0 10px;
          margin-bottom: 10px;
          color: #55616e;
          font-weight: normal;
        }
        .choose-company {
          height: 40px;
          width: 180px;
          padding: 0 0 0 10px;
          margin-bottom: 10px;
          color: #55616e;
          font-weight: normal;
        }
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 140px;
      }
    }
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 21px;
}
table thead tr {
  height: 37px;
  background: #f8f9fe;
  text-align: left;
}
table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 12px 0 12px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  height: 16px;
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  padding: 11px 0 10px 0;
}
.Invoice_table_header {
  .balance {
    width: 80px;
  }
  .companyName {
    width: 210px;
  }
  .contact {
    width: 130px;
  }
}
.speace {
  width: 120px;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}
.btn-link {
  bottom: 10px;
  color: black;
}
.dropdown-menu {
  width: 228px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  a {
    padding: 10px 15px;
    font-family: "Helvetica Neue";
    font-size: 16px;
    line-height: 20px;
  }
  a:hover {
    color: #51a3f3;
    height: 40px;
    background-color: #f8f9fe;
  }
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  //padding: 10px 15px 10px 0;
  float: right;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  padding: 12px 0 12px 0;
  text-align: left;
}
table thead th:first-child {
  padding-left: 20px;
}
table th:first-child {
  padding-left: 15px;
}
tbody th.created_by {
  line-height: 20px;
  height: 20px;
  padding: 7px 0 27px 0;
}
.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 13px 0 12px 0;
  color: #000000;
  font-weight: bold;
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 17px;
  // margin: 17px 0 37px 12px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding: 7px 0 7px 0;
}
th.smsText {
  color: #55616e;
  font-family: "Helvetica Neue";
  font-size: 14px;
  font-weight: normal;
  line-height: 25px;
  padding: 10px 0 10px 0;
}
th.status {
  padding: 10px 18px 10px 0;
  .approved {
    box-sizing: border-box;
    height: 24px;
    width: 80px;
    border: 2px solid #ffffff;
    border-radius: 100px;
    background-color: #24e2b8;
    color: #ffffff;
    font-family: "Helvetica Neue";
    font-size: 13px;
    font-weight: normal;
    line-height: 16px;
    padding: 4px 10px;
  }
  .rejected {
    box-sizing: border-box;
    height: 24px;
    width: 74px;
    border: 2px solid #ffffff;
    border-radius: 100px;
    background-color: #d2305b;
    color: #ffffff;
    font-family: "Helvetica Neue";
    font-size: 13px;
    font-weight: normal;
    line-height: 16px;
    padding: 4px 10px;
  }
}
th.icon {
  float: right;
  padding: 7px 5px 7px 0;
  .primary {
    // padding-top: 11px;
    width: 90px;
    height: 30px;
    font-size: 12px;
    line-height: 20px;
    border: 2px solid #ffffff;
    border-radius: 100px;
  }
  .primary.active {
    border: 2px solid #ffffff;
    border-radius: 100px;
    background-color: #24e2b8;
    color: #ffffff;
    // opacity: 0.68;
  }
  .svg-grey {
    fill: #55616e;
  }
}
th .svg-green {
  cursor: pointer;
  fill: #24e2b8;
  margin-right: 20px;
}
th .svg-red {
  cursor: pointer;
  fill: #d2305b;
}
.Invoice_table_sub_header th {
  height: 30px;
  color: #bdbfd8;
  font-family: "Helvetica Neue";
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 30px;
  padding: 5px 0 5px 15px;
}
th.allcompanies {
  padding-top: 20px;
}
</style>

